import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import TimelapseIcon from "@material-ui/icons/Timelapse";
import { DatePicker } from "@material-ui/pickers";
import { Tile, PageHeader } from "components/PageHeader";
import OrdersTable from "./OrdersTable";
import useGlobalStyles from "styles/globalStyles";
import useStyles from "./styles";

const OrdersHistory = ({ orders, selectedDate, onDateChange }) => {
  const global = useGlobalStyles();
  const classes = useStyles();

  return (
    <div className={global.root}>
      <Helmet>
        <title>Orders History</title>
      </Helmet>
      <div className={global.topBg}></div>
      <div className={global.container}>
        <PageHeader title="Orders History" icon={<TimelapseIcon fontSize="large" />}>
          <div className={global.grow}>
            <DatePicker
              label="Date:"
              value={selectedDate}
              onChange={onDateChange}
              animateYearScrolling
              InputProps={{ classes: { root: classes.white } }}
              classes={{ root: classes.datePicker }}
            />
          </div>
          <Tile title={"Total"} count={orders.length} />
        </PageHeader>
        <OrdersTable orders={orders} />
      </div>
    </div>
  );
};

OrdersHistory.propTypes = {
  orders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      to_go: PropTypes.bool,
      created_at: PropTypes.string,
      line_items: PropTypes.arrayOf(PropTypes.object),
    })
  ).isRequired,
  selectedDate: PropTypes.object.isRequired,
  onDateChange: PropTypes.func.isRequired,
};

export default OrdersHistory;
